import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";
import jwtService from "../common/jwt.service";
import {
    LOGIN,
    LOGOUT,
    REGISTER,
    CHECK_AUTH,
    UPDATE_USER,
    UPDATE_ADMIN_LOGGED_STATUS
} from "./actions.type";
import {
    SET_AUTH,
    PURGE_AUTH,
    SET_ERROR,
    UPDATING_ADMIN_LOGGEDIN_STATUS
} from "./mutations.type";

const state = {
    errors: null,
    user: {},
    isAuthenticatedClient: !!JwtService.getToken(),
    isAdminLoggedIn: false
};

const getters = {
    currentUserClient(state) {
        return state.user;
    },
    isAuthenticatedClient(state) {
        return state.isAuthenticatedClient;
    },
    isAdminLoggedIn(state) {
        return state.isAdminLoggedIn;
    }
};

const actions = {
    [LOGIN](context, credentials) {
        return new Promise((resolve) => {
            ApiService.post("/login", credentials)
                .then(async ({ data }) => {
                    window.localStorage.removeItem("adminLoggedIn");
                    // console.log(data && data.user && data.user.id != 1);
                    if (data && data.user) {
                        // && data.user.id != 1
                        await context.commit(SET_AUTH, data);
                    } else {
                        // data = { status: false, error: "Email Not registered" }
                    }
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                });
        });
    },
    [LOGOUT](context) {
        context.commit(PURGE_AUTH);
        context.commit(UPDATING_ADMIN_LOGGEDIN_STATUS);
    },
    [UPDATE_ADMIN_LOGGED_STATUS](context) {
        context.commit(UPDATING_ADMIN_LOGGEDIN_STATUS);
    },
    [REGISTER](context, credentials) {
        return new Promise((resolve, reject) => {
            ApiService.post("registration", { user: credentials })
                .then(({ data }) => {
                    window.localStorage.removeItem("adminLoggedIn");
                    // context.commit(SET_AUTH, data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                    reject(response);
                });
        });
    },
    [CHECK_AUTH](context) {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            ApiService.get("user-profile")
                .then(({ data }) => {
                    data.token = JwtService.getToken();
                    context.commit(SET_AUTH, data);
                    // Save UserData in Session
                    JwtService.saveUserData(data);
                    context.commit(UPDATING_ADMIN_LOGGEDIN_STATUS);
                })
                .catch(({ response }) => {
                    // console.log(typeof response)
                    if (typeof response == "undefined") {
                        jwtService.destroyToken();
                        window.location.href = "/";
                    }
                    // console.log('test',response);
                    // context.commit(SET_ERROR, response.data.errors);
                });
        } else {
            context.commit(PURGE_AUTH);
        }
    },
    [UPDATE_USER](context, credentials) {
        return new Promise((resolve, reject) => {
            ApiService.put("/update-profile", credentials)
                .then(async ({ data }) => {
                    await context.commit(SET_AUTH, data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                    reject(response);
                });
        });
    }
    // [UPDATE_USER](context, payload) {
    //   const { email, username, password, image, bio } = payload;
    //   const user = {
    //     email,
    //     username,
    //     bio,
    //     image
    //   };
    //   if (password) {
    //     user.password = password;
    //   }

    //   return ApiService.put("user", user).then(({ data }) => {
    //     context.commit(SET_AUTH, data);
    //     return data;
    //   });
    // }
};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
    async [SET_AUTH](state, data) {
        // console.log(state, data);
        state.isAuthenticatedClient = true;
        state.user = data.user;
        state.errors = {};
        await JwtService.saveToken(data.token);
    },
    [PURGE_AUTH](state) {
        state.isAuthenticatedClient = false;
        state.user = {};
        state.errors = {};
        JwtService.destroyToken();
    },
    [UPDATING_ADMIN_LOGGEDIN_STATUS](state) {
        state.isAdminLoggedIn =
            !!window.localStorage.getItem("adminLoggedIn") &&
            !!JwtService.getToken();
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
